export default __webpack_public_path__ + "static/media/charlesczeisler.31b4c2f7.jpg";